module.exports = __webpack_public_path__ + "img/cc-amex.0e957ce1.svg";